export type AiWidgetDirection = 'toTop' | 'toBottom';

export interface AiDestination {
  label: string;
  description: string;
  logo: string;
  baseUrl: string;
  queryKey: string;
}

export const PEEK_DURATION_MS = 3000;
export const PEEK_DELAY_MS = 760;
export const FOCUS_DELAY_MS = 460;
export const ENTRANCE_DURATION_MS = 1300;
// longhands (not the `mask` shorthand) so class order can't reset mask-composite
export const RING_MASK_CLASSES =
  'p-0.5 [mask-clip:content-box,border-box] [mask-composite:exclude] [mask-image:linear-gradient(theme(colors.site.neutrals.900)_0_0),linear-gradient(theme(colors.site.neutrals.900)_0_0)]';

export const DESTINATIONS: AiDestination[] = [
  {
    label: 'ChatGPT',
    description: 'Summarize this page and ask follow-ups',
    logo: 'https://assets.bairesdev.com/image/upload/www/static/openai_1758743827.svg',
    baseUrl: 'https://chat.openai.com/',
    queryKey: 'q',
  },
  {
    label: 'Grok',
    description: 'Summarize this page and ask follow-ups',
    logo: 'https://assets.bairesdev.com/image/upload/www/static/grok_1758743826.svg',
    baseUrl: 'https://x.com/i/grok/',
    queryKey: 'text',
  },
  {
    label: 'Perplexity',
    description: 'Summarize this page and ask follow-ups',
    logo: 'https://assets.bairesdev.com/image/upload/www/static/perplexity_1758743824.svg',
    baseUrl: 'https://www.perplexity.ai/search/new/',
    queryKey: 'q',
  },
  {
    label: 'Google Gemini',
    description: 'Summarize this page and ask follow-ups',
    logo: 'https://assets.bairesdev.com/image/upload/www/static/Gemini_tvfgaq.svg',
    baseUrl: 'https://www.google.com/search?udm=50&aep=11',
    queryKey: 'q',
  },
  {
    label: 'Claude',
    description: 'Summarize this page and ask follow-ups',
    logo: 'https://assets.bairesdev.com/image/upload/www/static/claude_1758743819.svg',
    baseUrl: 'https://claude.ai/new/',
    queryKey: 'q',
  },
];

export const PARTICLES: Array<{ dx: number; dy: number; light: boolean }> = [
  { dx: -44, dy: -38, light: false },
  { dx: 48, dy: -30, light: true },
  { dx: -52, dy: 10, light: false },
  { dx: 40, dy: 34, light: true },
  { dx: -8, dy: -56, light: false },
  { dx: 14, dy: 52, light: true },
  { dx: 60, dy: 4, light: false },
  { dx: -30, dy: 46, light: true },
];
